import { render, staticRenderFns } from "./IndexOnSale.vue?vue&type=template&id=5ce8ce3f"
import script from "./IndexOnSale.vue?vue&type=script&lang=js"
export * from "./IndexOnSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports